<template>
  <div id="centerLeft1">
    <div class="centerLeft1Top">
      <div class="centerLeft1Title">
        地区占比统计
      </div>

      <div class="industryType">
        <div style="margin-right: 37px;" :class="industryType == 0 ? 'actionAndustryType' : 'industryTypeItem'"
          @click="clickAction(0)">
          求职人员
        </div>
        <div style="margin-right: 24px;" :class="industryType == 1 ? 'actionAndustryType' : 'industryTypeItem'"
          @click="clickAction(1)">
          项目
        </div>
        <div style="margin-right: 24px;" :class="industryType == 2 ? 'actionAndustryType' : 'industryTypeItem'"
          @click="clickAction(2)">
          企业
        </div>
      </div>
    </div>

    <div class="centerLeft1Box">
      <!-- <div class="centerLeft1BoxTop">
        <div class="selectTitle">
          行业类型
        </div>
        <el-select style="width: 132px;height: 30px;margin-right: 34px;" class="select" v-model="value"
          placeholder="请选择">
          <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
          </el-option>
        </el-select>

        <div class="selectTitle">
          岗位类型
        </div>
        <el-select style="width: 132px;height: 30px;" class="select" v-model="value" placeholder="请选择">
          <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
          </el-option>
        </el-select>
      </div> -->

      <!-- <div class="industryType">
        <div style="margin-right: 37px;" :class="industryType == 0 ? 'actionAndustryType' : 'industryTypeItem'"
          @click="clickAction(0)">
          就业行业
        </div>
        <div style="margin-right: 24px;" :class="industryType == 1 ? 'actionAndustryType' : 'industryTypeItem'"
          @click="clickAction(1)">
          招聘行业
        </div>
      </div> -->
      <div id="chartInstance" ref="chartInstance">

      </div>
      <div class="tongjiList">
        <div class="tongjiListTop">
          <div class="tongjiListTopItem">
            地区
          </div>
          <div class="tongjiListTopItem">
            {{ industryType == 0 ? '求职者' : industryType == 1 ? '项目' : '企业' }}
          </div>
        </div>
        <div class="tongjiItemList">
          <div class="tongjiItem" :style="`height:${100 / nameList.length}% ;`" v-for="(item, index) in nameListReverse"
            :key="index">
            <span class="tongjiItemText">
              {{ item }}
            </span>
            <span class="tongjiItemText">
              {{ countListReverse[index] }}
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getAreaWantRateApi, getAreaProjectRateApi, getAreaCompanyRateApi } from '@/utils/api'
export default {
  data() {
    return {
      areaWantRate: [],
      areaProjectRate: [],
      areaCompanyRate: [],
      value: '',
      industryType: 0,
      nameList: [],
      countList: [],
      data: '',
      nameListReverse: [],
      countListReverse: []
    }
  },
  mounted() {
    this.getAreaWantRate()
  },
  methods: {

    async getAreaWantRate(data) {
      if (data) {
        this.data = data
      }
      let industryType = this.industryType
      // console.log(this.data);
      await (industryType == 0 ? getAreaWantRateApi : industryType == 1 ? getAreaProjectRateApi : getAreaCompanyRateApi)({
        ...this.data,
        size: 4
      }).then(res => {
        // console.log(res.data.data.nameList);
        this.nameList = res.data.data.nameList
        this.countList = res.data.data.countList
        // this.nameListReverse = this.nameList.sort(function (a, b) {
        //   return b - a;
        // });
        // console.log(this.nameListReverse);
        // this.nameList.push('ssss')
        // this.countList.push(10)
        this.chartInstanceInit()
      })
      await (industryType == 0 ? getAreaWantRateApi : industryType == 1 ? getAreaProjectRateApi : getAreaCompanyRateApi)({
        ...this.data,
        size: 4
      }).then(res => {
        // console.log(res.data.data.nameList);
        // this.nameList = res.data.data.nameList
        this.nameListReverse = res.data.data.nameList.reverse()
        this.countListReverse = res.data.data.countList.reverse()
      })
    },




    chartInstanceInit() {
      const chartInstance = this.$echarts.init(this.$refs.chartInstance)
      const initOption = {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          }
        },
        grid: {
          x: 0,
          y: 16,
          x2: 0,
          y2: 0,
          containLabel: true
        },
        xAxis: {
          type: 'value',
          boundaryGap: [0, 0.01],
          inverse: true,
          axisLabel: {
            show: false
          },
          axisLine: {
            show: false,
          },
          splitLine: {
            show: false
          }
        },
        yAxis: {
          type: 'category',
          data: this.nameList,
          position: 'right',
          axisLabel: {
            show: false
          },
          axisLine: {
            show: false,
          },
          splitLine: {
            show: true,
            lineStyle: {
              color: '#3b3b3c',
              width: 1,
              type: 'dotted'
            }
          },
        },
        series: [
          {
            type: 'bar',
            barWidth: 24,
            data: this.countList,
            itemStyle: {
              color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                offset: 0,
                color: 'RGBA(14, 218, 242, 0.5)'
              },
              {
                offset: 1,
                color: 'RGBA(14, 68, 242, 0.5)'
              }]),
            },
            label: {
              normal: {
                show: true,
                // //数值展示在最右边，通过调节offset显示
                position: 'insideLeft',
              }
            }
          }
        ]
      }
      // console.log(initOption);
      chartInstance.setOption(initOption)
    },

    //切换行业类型
    clickAction(e) {
      this.industryType = e
      this.getAreaWantRate()

    },
  }
}
</script>

<style lang="scss" scoped>
.select {

  ::v-deep .el-input__inner {
    height: 30px;
    line-height: 30px;
    border: none;
    border-radius: 4px;
    background: linear-gradient(90deg, #008490 0%, #011735 52%, #00808C 100%);
  }

  ::v-deep .el-input__icon {
    line-height: 30px;
  }
}



#centerLeft1 {
  width: 735px;
  height: 290px;
  background-image: url('../assets/center2bg.png');
  background-size: 100% 100%;


  .centerLeft1Title {
    font-weight: bold;
    font-size: 28px;
    color: #0EE1F4;
    padding-left: 90px;
  }

  .centerLeft1Box {
    box-sizing: border-box;
    padding: 10px;
    width: 100%;
    display: flex;
  }

  .centerLeft1BoxTop {
    display: flex;
    align-items: center;
    height: 30px;
    margin-bottom: 14px;
  }

  .selectTitle {
    font-weight: 400;
    font-size: 16px;
    color: #FFFFFF;
    margin-right: 14px
  }

  .industryType {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    z-index: 99999;
  }

  .industryTypeItem {
    width: 86px;
    height: 30px;
    // background: linear-gradient(90deg, #008490 0%, #011735 52%, #00808C 100%);
    background-image: url('../assets/unSelect.png');
    background-repeat: no-repeat;
    background-size: 100% 100%;
    border-radius: 4px;
    font-size: 14px;
    font-weight: 400;
    color: #2E8989;
    text-align: center;
    line-height: 30px;
    cursor: pointer;
  }

  .actionAndustryType {
    width: 86px;
    height: 30px;
    background-image: url('../assets/select.png');
    background-repeat: no-repeat;
    background-size: 100% 100%;
    // background: linear-gradient(90deg, #008490 0%, #011735 52%, #00808C 100%);
    border-radius: 4px;
    // border: 1px solid;
    font-weight: 400;
    font-size: 14px;
    color: #FFFFFF;
    line-height: 30px;
    text-align: center;
    cursor: pointer;
  }
}

#chartInstance {
  width: 440px;
  height: 210px;
}

.tongjiList {
  flex: 1;
}

.tongjiListTop {
  display: flex;
  flex: 1;
  padding: 0 30px;
  // margin-bottom: 20px;

  .tongjiListTopItem {
    font-size: 12px;
    color: #FFFFFF;
    flex: 1;
    text-align: center;
  }
}

.tongjiItemList {
  padding: 0 30px 0;
  // margin-bottom: 20px;
  height: 190px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  .tongjiItem {

    font-size: 12px;
    color: #FFFFFF;
    // margin-bottom: 20px;
    // height: 24px;
    // line-height: 24px;
    display: flex;
    align-items: center;

    .tongjiItemText {
      display: inline-block;
      width: 50%;
      text-align: center;
    }
  }
}
</style>
